import React, {Component} from 'react';
import {View, TouchableOpacity, I18nManager, ActivityIndicator, Image, Platform, Alert} from 'react-native';
import {moderateScale} from "../../../../../tools/Scaling";
import * as NavigationService from '../../../../../redux/NavigationService';
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import i18n from "../../../../../I18n/i18n";
import {serviceActionListNotSendMyApply, serviceActionRtl} from "../../../splash/action/ActionSplashGetAllData";
import {connect} from "react-redux";
//import {callWebservice} from "../../../../../redux/actions/ActionSubmitRequestScreen";
import store from "../../../../../redux/store";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import {typeExport} from "../../../../../redux/store/type";
import HMIcon from "../../../../../customviews/HMIcon";
import HMAlert from "../../../../../customviews/HMAlert";
import HMAnimation from "../../../../../customviews/animation/HMAnimation";
import {Tools} from "../../../../../tools/Tools";
import HMLoading from "../../../../../customviews/HMLoading";


class AdapterListMyApply extends Component {

    componentWillMount() {

    }

    constructor(props) {
        super(props);
    }

    state = {
        indexLoading: -1
    }

    componentWillReceiveProps(propss) {

    }

    componentWillUnmount() {

    }

    setData(item) {
        //   this.props.callService(urlMyApplyScreen, `?type=${this.props.typee}&city=`, TypeGetMyApplyScreen, 'POST',page,this.props.item_count)
        this.props.callService(typeExport.urlSetMyApplyScreen, `?property=${item.id}&apply_notify=${!(item.apply_notify)}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeSetMyApplyScreen, 'POST', 0, 0, item.id)
        // this.props.callService(urlMyApplyScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, TypeGetMyApplyScreen, 'POST', page, 8)

    }

    /*  isCherries(fruit) {
         return fruit.name === 'cherries';
     }*/
    render() {
        let {item, index, navigation, item_parent, hiddenModal} = this.props;
        // let fileAudio = item.audio || item.audio === null ? item.audio : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'audio/aac')))
        // let fileImage = item.image || item.image === null ? item.image : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'image/jpeg')))
        // let fileVideo = item.video || item.video === null ? item.video : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'video/mp4')))

        // (itemFiles.search('audio/') >= 0));
        // (itemFiles.search('image/') >= 0));
        // (itemFiles.search('video/') >= 0));

        // let itemFiles = item.files;
        let fileAudio = item.audio || item.audio === null ? item.audio : (item.files && item.files.length > 0 && (item.files.find(k => k.type.search('audio/') >= 0)));
        let fileImage = item.image || item.image === null ? item.image : (item.files && item.files.length > 0 && (item.files.find(k => k.type.search('image/') >= 0)));
        let fileVideo = item.video || item.video === null ? item.video : (item.files && item.files.length > 0 && (item.files.find(k => k.type.search('video/') >= 0)));
        let {ListNotSendMyApply} = store.getState().reducerSplashGetAllData
        return (


            <TouchableOpacity
                style={{
                    flex: 1,
                    //width: "49%",
                    //alignSelf: "center",
                    paddingHorizontal: moderateScale(4),
                    marginHorizontal: moderateScale(8)
                }}
                onPress={() => {
                    //  this.props.callServiceShowWebView("")
                    NavigationService.navigateParams("DetailsRequestScreen", {
                        item: item
                        // item: JSON.stringify(item)
                    })
                    hiddenModal()
                }}
                //onPress={() =>NavigationService.navigateParams("VideoScreen", {id: item.id}) }

            >
                <View
                    style={{
                        padding: moderateScale(6),
                        // flexDirection: "row",
                        // width: "100%",
                        flex: 1,
                        marginVertical: moderateScale(4),
                        borderRadius: moderateScale(5),
                        backgroundColor: Colors.backgroundColor,

                        // justifyContent: "flex-end"
                    }}>

                    <View style={{flex: 1, flexDirection: 'row',}}>
                        <View style={{flexDirection: 'row', flex: .31,}}>
                            <HMTextView type={"bold"}

                                        style={{
                                            fontSize: moderateScale(14),
                                            marginHorizontal: moderateScale(5),
                                            color: Colors.blackLight,
                                            // marginTop: moderateScale(10)
                                        }}
                                // text={"1423578"}
                                        text={item.code ? item.code : (I18nManager.getConstants().isRTL ? " ." + (index + 1) : (index + 1) + " .")}
                                //   text={"98/03/21"}
                            />
                        </View>
                        <View style={{
                            flex: .38, flexDirection: 'row',
                            alignItems: 'center', justifyContent: 'center'
                            //    backgroundColor:'#96ee5b'
                        }}>
                            <HMTextView
                                //type={"bold"}

                                style={{
                                    fontSize: moderateScale(14),
                                    color: Colors.colorDark,
                                    textAlign: 'center',
                                    //alignSelf:'center',
                                    // marginTop: moderateScale(10)
                                }}
                                //  text={'1398/05/03'}
                                text={item.createdtime ? item.createdtime : item.date}
                                //   text={"98/03/21"}
                            />
                        </View>
                        <View style={{flexDirection: 'row', flex: .31, justifyContent: 'flex-end'}}>
                            {
                                item._operation ?
                                    (
                                        this.state.RequestSubmitPending ?
                                            <HMLoading/>
                                            :
                                            <View style={{flexDirection: "row"}}>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        if (store.getState().reducerSplashGetAllData.Connection) {
                                                            this.setState({
                                                                    RequestSubmitPending: true
                                                                },
                                                                () => {
                                                                    Tools.RequestSubmit("POST", typeExport._baseUrlSaina, null, 5, () => {
                                                                        container.setState({
                                                                            RequestSubmitPending: false
                                                                        })
                                                                    })
                                                                })
                                                            /*     store.dispatch(callWebservice(
                                                                     null,
                                                                     typeExport._baseUrlSaina,
                                                                     item,
                                                                     typeExport.TypeSetSubmitRequestScreen,
                                                                     "POST",
                                                                     this.props.token,
                                                                     item_parent,
                                                                     index
                                                                 ))*/

                                                        } else {
                                                            HMAlert(i18n.t('constant.message'),
                                                                i18n.t('constant.errorNetwork'), [
                                                                    // {text: 'Ask me later', onPress: () => {}},
                                                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                    {
                                                                        text: i18n.t('constant.ok'),
                                                                        onPress: () => {
                                                                        }
                                                                    },
                                                                ],
                                                                {cancelable: true}
                                                            )
                                                        }
                                                    }}
                                                >
                                                    <HMTextView

                                                        //type={"bold"}

                                                        style={{
                                                            fontSize: moderateScale(14),
                                                            color: Colors.blue,
                                                            // marginTop: moderateScale(10)
                                                        }}
                                                        text={'ارسال مجدد'}
                                                        //   text={"98/03/21"}
                                                    />
                                                </TouchableOpacity>
                                                <View style={{width: moderateScale(6)}}/>
                                                <TouchableOpacity
                                                    onPress={async () => {


                                                        ListNotSendMyApply.splice(index, 1);

                                                        await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApplyOffline + item.type, ListNotSendMyApply)
                                                        store.dispatch(serviceActionListNotSendMyApply(ListNotSendMyApply));
                                                    }}
                                                >
                                                    <HMTextView
                                                        //type={"bold"}

                                                        style={{
                                                            fontSize: moderateScale(12),
                                                            color: Colors.red,
                                                            // marginTop: moderateScale(10)
                                                        }}
                                                        text={"حذف"}
                                                        //   text={"98/03/21"}
                                                    />
                                                </TouchableOpacity>
                                            </View>
                                    )
                                    :
                                    <HMTextView type={"bold"}

                                                style={{
                                                    fontSize: moderateScale(14),
                                                    color: item.color ? item.color : Colors.gray,
                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={item.status}
                                        //   text={"98/03/21"}
                                    />

                            }

                        </View>
                    </View>
                    <View style={{
                        width: "100%",
                        padding: moderateScale(4)
                        //    justifyContent: 'flex-end'
                    }}>

                        <HMTextView
                            type={"bold"}

                            style={{
                                fontSize: moderateScale(14),
                                color: Colors.colorDark,
                                // marginTop: moderateScale(10)
                            }}
                            //text={'آسیب های اجتماعی'}
                            text={item.title ? item.title : item.category}
                            //   text={"98/03/21"}
                            styleRoot={{
                                flexDirection: 'row',
                                flex: 1,
                                // justifyContent: "flex-end",
                                flexWrap: 'wrap',
                                //    alignItems: 'center', justifyContent: 'center'
                            }}
                        />

                        <HMTextView
                            //type={"bold"}


                            style={{
                                fontSize: moderateScale(13),

                                color: Colors.gray,
                                // marginTop: moderateScale(10)
                            }}
                            text={item.subject}
                            styleRoot={{
                                flexDirection: 'row',
                                flex: 1,
                                // justifyContent: "flex-end",
                                flexWrap: 'wrap',
                                //    alignItems: 'center', justifyContent: 'center'
                            }}
                            //   text={"98/03/21"}
                        />
                    </View>
                    {
                        item.comment == null && item.files == null ?
                            null
                            :
                            <View style={{width: "100%", flexDirection: 'row',}}>
                                <View style={{flex: .7, flexDirection: 'row',}}>
                                    {
                                        item.latitude==null ?
                                            null
                                            :
                                            <TouchableOpacity style={{
                                                //flex: .3,
                                                flexDirection: 'row',

                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginHorizontal: moderateScale(5)
                                            }}>
                                                <HMIcon name={"md-pin"} style={{
                                                    alignSelf: 'center',
                                                    // width: moderateScale(14),
                                                    color: item.latitude && item.latitude != null && item.latitude != '' && item.latitude != 'null' ? Colors.colorPrimaryDark : Colors.gray,
                                                    fontSize: Platform.OS !== 'android' ? moderateScale(18) : moderateScale(14),
                                                    textAlign: 'center'
                                                }}/>
                                            </TouchableOpacity>

                                    }

                                    {
                                        item.files == null ?
                                            null
                                            :
                                            <TouchableOpacity style={{
                                                // flex: .33,

                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginHorizontal: moderateScale(5)
                                            }}>
                                                <HMIcon name={"md-image"} style={{
                                                    alignSelf: 'center',
                                                    // width: moderateScale(14),
                                                    color: ((item.files && item.files.length > 0 && fileImage && fileImage.file) || item.image) ? Colors.colorPrimaryDark : Colors.gray,
                                                    fontSize: Platform.OS !== 'android' ? moderateScale(18) : moderateScale(14),
                                                    textAlign: 'center'
                                                }}/>
                                            </TouchableOpacity>

                                    }
                                    {

                                        item.files == null ?
                                            null
                                            :
                                            <TouchableOpacity style={{
                                                // flex: .33,
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginHorizontal: moderateScale(5)
                                            }}>
                                                <HMIcon name={"md-videocam"} style={{
                                                    alignSelf: 'center',
                                                    // width: moderateScale(14),
                                                    color: ((item.files && item.files.length > 0 && fileVideo && fileVideo.file) || item.video) ? Colors.colorPrimaryDark : Colors.gray,
                                                    fontSize: Platform.OS !== 'android' ? moderateScale(18) : moderateScale(14),
                                                    textAlign: 'center'
                                                }}/>
                                            </TouchableOpacity>

                                    }
                                    {

                                        item.files == null ?
                                            null
                                            :
                                            <TouchableOpacity style={{
                                                // flex: .33,
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginHorizontal: moderateScale(5)
                                            }}>
                                                <HMIcon name={"md-mic"} style={{
                                                    alignSelf: 'center',
                                                    // width: moderateScale(14),
                                                    color: ((item.files && item.files.length > 0 && fileAudio && fileAudio.file) || item.audio) ? Colors.colorPrimaryDark : Colors.gray,
                                                    fontSize: Platform.OS !== 'android' ? moderateScale(18) : moderateScale(14),
                                                    textAlign: 'center'
                                                }}/>
                                            </TouchableOpacity>

                                    }

                                </View>
                                {
                                    item._operation || item.comment == null ?
                                        <View style={{flex: .3, flexDirection: 'row', justifyContent: 'flex-end'}}/>
                                        :
                                        <View style={{flex: .3, flexDirection: 'row', justifyContent: 'flex-end'}}>
                                            <HMIcon
                                                name={"message"}
                                                type={"MaterialCommunityIcons"}
                                                style={{
                                                    alignSelf: 'center',
                                                    // width: moderateScale(14),
                                                    color: Colors.colorDark,
                                                    marginHorizontal: moderateScale(5),
                                                    fontSize: Platform.OS !== 'android' ? moderateScale(18) : moderateScale(14),
                                                    textAlign: 'center'
                                                }}/>
                                            <HMTextView

                                                //type={"bold"}

                                                style={{
                                                    fontSize: moderateScale(13),
                                                    color: Colors.gray,

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={item.comment ? (item.comment.length > 0 ? item.comment.length + "" : "0") : (item.lastWork && item.lastWork.length > 0 ? item.lastWork.length + "" : "0")}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                }

                            </View>
                    }


                </View>


            </TouchableOpacity>
            //     <HMAnimation
            // indexList={index}
            // animationTypeIndex={1}
            // animationTypeIndexSub={3}
            // colorIndex={1}
            // styleRoot={{
            //     flex: 1,
            //         //width: "49%",
            //         //alignSelf: "center",
            //         paddingHorizontal: moderateScale(4),
            //         marginHorizontal: moderateScale(8)
            // }}
            // StartAnimation
            // //onPress={this.handleRowPressed}
            // // useNativeDriver={
            // //     NATIVE_INCOMPATIBLE_ANIMATIONS.indexOf(item) === -1
            // // }
            // >
            //     </HMAnimation>

        );
    }

}

const mapStateToProps = state => {
    return {

        // resultsSet: state.reducerMyApplyScreen.resultsSet,
        // isLoadingSet: state.reducerMyApplyScreen.isLoadingSet,
        // NoInternetDialogSet: state.reducerMyApplyScreen.NoInternetDialogSet,
        token: state.reducerSplashGetAllData.token,
        DataSplashScreen: state.reducerSplashGetAllData,
        //  id: state.reducerMyApplyScreen.id,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        // callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(url, params, type, typeConnection, page, item_count, id)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AdapterListMyApply);
